<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='sys sys-add' class='navbarbtn' v-if='showAddPower'
        @click='showMainTableAddDialogMD'>
        新 增
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='printPickItemRequest'>
        打 印
      </el-button>

      <el-button type='primary' icon='sys sys-check' class='navbarbtn' v-if='showCheckPower'
        @click='checkPPR'>
        审 核
      </el-button>

      <el-button type='danger' icon='sys sys-cancelcheck' class='navbarbtn' v-if='showUnCheckPower'
        @click='cancelCheckPPR'>
        反审核
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.subBillNo' style='width: 125px;' placeholder='委外订单号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :expandRowKeys='mainTable.expandRowKeys'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='编辑' placement='top-start' v-if='showEditPower && scope.data.row.Status ==="0"'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showEditPickItemRequestDialogMD(scope.data.row)'><i class='sys sys-edit'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletePower && scope.data.row.Status ==="0"'>
          <el-button type='danger' circle style='padding: 4px;'
            @click='deletedPickItemRequest(scope)'><i class='sys sys-delete'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 40px; text-align: center;'><span style='color: #42426F;'>操作</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 40px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 140px; text-align: left;'><span style='color: #42426F;'>投料单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>投料行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>计划数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>申请数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>已领数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>原申请数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 140px; text-align: left;'><span style='color: #42426F;'>委外单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: left;'><span style='color: #42426F;'>委外单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>备注</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppre in scope.data.row.detailDt1'
            :key='ppre.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 40px; text-align: center;'>
              <el-button type='primary' style='padding: 2px;' size='mini' v-if='showEditPower && scope.data.row.Status !== "0" && ppre.Qty > ppre.PickQty'
                @click='showEditQtyAndRemarkDialogMD(ppre)'>变更
              </el-button>
            </div>
            <div class='expand-row' style='min-width: 40px; text-align: right;'><span style='color: blue;'>{{ppre.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 140px; text-align: left;'><span style='color: blue;'>{{ppre.PPBomBillNo}} </span></div>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppre.PPBomEntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppre.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppre.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppre.PPBomQty}}{{ppre.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppre.Qty}}{{ppre.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppre.PickQty}}{{ppre.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppre.OldQty}}{{ppre.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 140px; text-align: left;'><span style='color: blue;'>{{ppre.SubBillNo}} </span></div>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppre.SubEntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppre.Remark}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppre.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog title='新增发料申请单' :visible.sync='showMainTableAddDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='addMainInfo.SourceTranType' placeholder='请选择' :clearable='false'
          class='inputField-input' disabled
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableMultSelectSimple
          class='inputField-input'
          :disabled='addMainInfo.SourceTranType === "0"'
          @change='sourceInterIDChange'
          customFilterStr=" AND Status IN ('1','2') AND SubStatus IN ('1','2') AND SubMrpClosed IN ('0')"
          style='width: 300px;' tableCode='PM_SubPPBomEntry'></TableMultSelectSimple>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          仓  库
        </div>
        <el-select v-model='addMainInfo.StockID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备  注
        </div>
        <el-input v-model='addMainInfo.Remark' size='mini' style='width: 300px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-table :data='addEntryInfo' border :height='getEntryTableHeight()'
        ref='addEntryInfoTable' style='margin-top: 80px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='200'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='200'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='QtyMust' label='计划数量' width='80'>
        </el-table-column>
        <el-table-column prop='WMSRequestQty' label='已申请数量' width='100'>
        </el-table-column>
        <el-table-column prop='WMSPickQty' label='已领数量' width='80'>
        </el-table-column>
        <el-table-column prop='RequestQty' label='本次申请数量' width='120'>
          <template #header>
            <span style='color: blue;'>本次申请数量</span>
          </template>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.RequestQty'
              style='width: 100px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='InvQty' label='条码库存' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='MachinePos' label='工位' width='100'>
        </el-table-column>
        <el-table-column prop='Note' label='投料单备注' width='200'>
        </el-table-column>
        <el-table-column prop='PPBomBillNo' label='投料单号' width='120'>
        </el-table-column>
        <el-table-column prop='EntryID' label='投料单行号' width='120'>
        </el-table-column>
        <el-table-column prop='SubBillNo' label='委外订单号' width='140'>
        </el-table-column>
        <el-table-column prop='OrderEntryID' label='委外订单行号' width='140'>
        </el-table-column>
        <el-table-column prop='Remark' label='备注' width='200'>
          <template #header>
            <span style='color: blue;'>备注</span>
          </template>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.Remark'
              style='width: 180px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='MTONo' label='计划跟踪号' width='100'>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deleteAddEntryInfoOne(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button class='inputField-input' v-if='addMainInfo.SourceTranType === "88"'
          type='primary' @click='autoCompleteRequestQty()' size='mini'>自动填充申请数量</el-button>
        <el-button type='primary' @click='pickItemRequest()' size='mini'>申请</el-button>
        <el-button @click='showMainTableAddDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='编辑发料申请单' :visible.sync='showEditPickItemRequestDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='editMainInfo.SourceTranType' placeholder='请选择' disabled
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableMultSelectSimple
          class='inputField-input'
          :disabled='editMainInfo.SourceTranType === "0"'
          @change='editSourceInterIDChange'
          customFilterStr=" AND Status IN ('1','2') AND SubStatus IN ('1','2') AND SubMrpClosed IN ('0')"
          style='width: 300px;' tableCode='PM_SubPPBomEntry'></TableMultSelectSimple>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          仓  库
        </div>
        <el-select v-model='editMainInfo.StockID' placeholder='请选择'
          class='inputField-input'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备  注
        </div>
        <el-input v-model='editMainInfo.Remark' size='mini' style='width: 300px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-table :data='editEntryInfo' border :height='getEntryTableHeight()'
        ref='editEntryInfoTable' style='margin-top: 80px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='200'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='QtyMust' label='计划数量' width='80'>
        </el-table-column>
        <el-table-column prop='WMSRequestQty' label='已申请数量' width='100'>
        </el-table-column>
        <el-table-column prop='WMSPickQty' label='已领数量' width='80'>
        </el-table-column>
        <el-table-column prop='RequestQty' label='本次申请数量' width='120'>
          <template #header>
            <span style='color: blue;'>本次申请数量</span>
          </template>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.RequestQty'
              style='width: 100px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='MachinePos' label='工位' width='100'>
        </el-table-column>
        <el-table-column prop='Note' label='投料单备注' width='200'>
        </el-table-column>
        <el-table-column prop='PPBomBillNo' label='投料单号' width='120'>
        </el-table-column>
        <el-table-column prop='EntryID' label='投料单行号' width='120'>
        </el-table-column>
        <el-table-column prop='SubBillNo' label='委外订单号' width='140'>
        </el-table-column>
        <el-table-column prop='OrderEntryID' label='委外订单行号' width='140'>
        </el-table-column>
        <el-table-column prop='Remark' label='备注' width='200'>
          <template #header>
            <span style='color: blue;'>备注</span>
          </template>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.Remark'
              style='width: 180px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='MTONo' label='计划跟踪号' width='100'>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='editDeleteAddEntryInfoOne(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button class='inputField-input' v-if='editMainInfo.SourceTranType === "88"'
          type='primary' @click='editAutoCompleteRequestQty()' size='mini'>自动填充申请数量</el-button>
        <el-button type='primary' @click='editPickItemRequest()' size='mini'>保存</el-button>
        <el-button @click='showEditPickItemRequestDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='变更' :visible.sync='showEditQtyAndRemarkDialog' width='385px'
      top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 85px; text-align: left'>
            变更后数量
          </div>
          <el-input v-model='newQty'
            size='mini' style='width: 250px;'>
          </el-input>
        </div>
        <div style='margin-top: 10px;'>
          <div class='inputField-label' style='width: 85px; text-align: left'>
            变更后备注
          </div>
          <el-input v-model='newRemark' type='textarea'
            size='mini' style='width: 250px;'>
          </el-input>
        </div>
        <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
          <el-button type='primary' @click='saveEdit()' size='mini'>保存</el-button>
          <el-button @click='showEditQtyAndRemarkDialog = false' size='mini'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import TableMultSelectSimple from '@/components/custom/TableMultSelectSimple.vue'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'SubPickItemRequest',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableMultSelectSimple
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PM_SubPickRequest',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',
        subBillNo: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showMainTableAddDialog: false,
      addMainInfo: {
        SourceTranType: '88',
        StockID: '',
        Remark: ''
      },
      addEntryInfo: [],
      sourceTranTypes: [],
      stocks: [],

      showEditPickItemRequestDialog: false,
      editMainInfo: {
        SourceTranType: '88',
        StockID: '',
        Remark: '',
        BillNo: ''
      },
      editEntryInfo: [],

      showEditQtyAndRemarkDialog: false,
      editRow: {},
      newQty: 0,
      newRemark: '',

      showAddPower: false,
      showEditPower: false,
      showDeletePower: false,
      showPrintPower: false,
      showCheckPower: false,
      showUnCheckPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.sourceTranTypes = code.getCode(codes, 'WMS_TranType', ['88'])
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND Deleted='0' AND TypeId='500'")

    await tableContentPromise
    await tableFilterInfoPromise
    const stockObj = await stockObjPromise
    that.stocks = stockObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.subBillNo) {
        const subBillNos = that.mainTable.subBillNo.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < subBillNos.length; i++) {
          detail1FilterStr += " OR SubBillNo LIKE'%" + subBillNos[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '0') {
        return { 'background-color': 'orange' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 新增发料申请单弹出框显示方法
    showMainTableAddDialogMD: function () {
      const that = this
      that.showMainTableAddDialog = true
      that.addMainInfo = {
        SourceTranType: '88',
        StockID: '',
        Remark: ''
      }
      that.addEntryInfo = []
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 获取弹出框中表格高度
    getEntryTableHeight: function () {
      return window.innerHeight - 210 + 'px'
    },

    // 源单改变方法
    sourceInterIDChange: async function (rows) {
      const that = this
      const itemIDs = []
      if (rows.length <= 0) {
        return
      }
      rows.forEach((dt) => {
        dt.Remark = ''
        dt.ProducetItemID = ''
      })
      const addEntryInfo = rows
      for (let i = 0; i < addEntryInfo.length; i++) {
        addEntryInfo[i].RequestQty = 0
        itemIDs.push(addEntryInfo[i].ItemID)
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetItemQRCodeQty', {
        itemIDs: itemIDs
      })
      if (rtnObj.error === '000000') {
        for (let i = 0; i < addEntryInfo.length; i++) {
          addEntryInfo[i].InvQty = 0
          for (let j = 0; j < rtnObj.tableContent.length; j++) {
            if (rtnObj.tableContent[j].ItemID === addEntryInfo[i].ItemID) {
              addEntryInfo[i].InvQty = rtnObj.tableContent[j].InvQty
              break
            }
          }
        }
        for (let i = 0; i < addEntryInfo.length; i++) {
          let haveFlag = false
          for (let j = 0; j < that.addEntryInfo.length; j++) {
            if (addEntryInfo[i].InterID === that.addEntryInfo[j].InterID && addEntryInfo[i].EntryID === that.addEntryInfo[j].EntryID) {
              haveFlag = true
            }
          }
          if (!haveFlag) {
            that.addEntryInfo.push(addEntryInfo[i])
          }
        }
        that.$refs.addEntryInfoTable.doLayout()
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 弹出框表格行删除方法
    deleteAddEntryInfoOne: function (index) {
      const that = this
      that.addEntryInfo.splice(index, 1)
    },

    // 自动填充申请数量
    autoCompleteRequestQty: function () {
      const that = this
      for (let i = 0; i < that.addEntryInfo.length; i++) {
        let precision = that.addEntryInfo[i].Precision
        if (typeof (precision) !== 'number') {
          precision = 0
        }
        that.addEntryInfo[i].RequestQty = that.addEntryInfo[i].QtyMust - that.addEntryInfo[i].WMSRequestQty
        that.addEntryInfo[i].RequestQty = (that.addEntryInfo[i].RequestQty * Math.pow(10, precision) -
          that.addEntryInfo[i].RequestQty * Math.pow(10, precision) % 1 + ((that.addEntryInfo[i].RequestQty * Math.pow(10, precision) % 1) > 0 ? 1 : 0)) / Math.pow(10, precision)
      }
      that.$refs.addEntryInfoTable.doLayout()
    },

    // 申请
    pickItemRequest: async function () {
      const that = this
      if (!that.addMainInfo.SourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (that.addMainInfo.SourceTranType && that.addEntryInfo.length <= 0) {
        that.$message.error('请选择源单！')
        return
      }
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.addEntryInfo.length; i++) {
        if (!that.addEntryInfo[i].ItemID) {
          that.$message.error('请选择物料')
          return
        }
        if (that.addEntryInfo[i].ICMOInterID !== that.addEntryInfo[0].ICMOInterID) {
          that.$message.error('请选择相同的委外订单的投料单！')
          return
        }
        if (!numberReg.test(that.addEntryInfo[i].RequestQty)) {
          that.$message.error('本次申请数量必须为数字！')
          return
        }
        if (parseFloat(that.addEntryInfo[i].RequestQty) < 0) {
          that.$message.error('本次申请数量不得小于0！')
          return
        }
        if (parseFloat(that.addEntryInfo[i].RequestQty) <= 0) {
          that.$message.error('本次申请数量必须大于0！')
          return
        }
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/OutsourcingManagement.SubContract.SubPickItemRequest', {
        main: that.addMainInfo,
        entrys: that.addEntryInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showMainTableAddDialog = false
        that.$message.success('申请成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除发料申请
    deletedPickItemRequest: function (scope) {
      const that = this
      that.$confirm('确定要删除该发料申请单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/OutsourcingManagement.SubContract.DeleteSubPickItemRequest', {
          pickRequestNo: scope.data.row.PickRequestNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 打印
    printPickItemRequest: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const rows = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        rows.push(that.mainTable.selections[i].PickRequestNo)
      }
      const dataJson = JSON.stringify(rows)
      window.open('/WebPrint/Print.Print.GetSubPickRequetDataSet?SubPickRequestNos=' + dataJson + '&reportName=SubPickRequest.rpt')
    },

    // 审核
    checkPPR: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '0') {
          that.$message.error('请选择未审核数据！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/OutsourcingManagement.SubContract.SubPickItemRequestCheck', {
        pprs: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('审核成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 反审核
    cancelCheckPPR: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '1') {
          that.$message.error('请选择已审核数据！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/OutsourcingManagement.SubContract.SubPickItemRequestUnCheck', {
        pprs: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('反审核成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 编辑发料申请单弹出框显示方法
    showEditPickItemRequestDialogMD: async function (row) {
      const that = this
      that.showEditPickItemRequestDialog = true
      that.editMainInfo = {
        BillNo: row.PickRequestNo,
        SourceTranType: row.detailDt1[0].SourceTranType,
        StockID: row.StockID,
        Remark: row.Remark
      }
      that.editEntryInfo = []
      for (let i = 0; i < row.detailDt1.length; i++) {
        that.editEntryInfo.push(Object.assign({}, row.detailDt1[i], {
          WMSRequestQty: row.detailDt1[0].SourceTranType === '0' ? 0 : row.detailDt1[i].PPBomEWMSRequestQty - row.detailDt1[i].Qty,
          WMSPickQty: row.detailDt1[0].SourceTranType === '0' ? 0 : row.detailDt1[i].PPBomEWMSPickQty,
          QtyMust: row.detailDt1[0].SourceTranType === '0' ? 0 : row.detailDt1[i].PPBomQty,
          RequestQty: row.detailDt1[i].Qty,
          Note: row.detailDt1[i].PPBomENote,
          InterID: row.detailDt1[i].PPBomInterID,
          EntryID: row.detailDt1[i].PPBomEntryID,
          ICMOInterID: row.detailDt1[i].SubInterID,
          OrderEntryID: row.detailDt1[i].SubEntryID
        }))
      }
    },

    // 编辑源单改变方法
    editSourceInterIDChange: async function (rows) {
      const that = this
      const itemIDs = []
      if (rows.length <= 0) {
        return
      }
      rows.forEach((dt) => {
        dt.Remark = ''
      })
      const editEntryInfo = rows
      for (let i = 0; i < editEntryInfo.length; i++) {
        editEntryInfo[i].RequestQty = 0
        itemIDs.push(editEntryInfo[i].ItemID)
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetItemQRCodeQty', {
        itemIDs: itemIDs
      })
      if (rtnObj.error === '000000') {
        for (let i = 0; i < editEntryInfo.length; i++) {
          editEntryInfo[i].InvQty = 0
          for (let j = 0; j < rtnObj.tableContent.length; j++) {
            if (rtnObj.tableContent[j].ItemID === editEntryInfo[i].ItemID) {
              editEntryInfo[i].InvQty = rtnObj.tableContent[j].InvQty
              break
            }
          }
        }
        for (let i = 0; i < editEntryInfo.length; i++) {
          let haveFlag = false
          for (let j = 0; j < that.editEntryInfo.length; j++) {
            if (editEntryInfo[i].InterID === that.editEntryInfo[j].InterID && editEntryInfo[i].EntryID === that.editEntryInfo[j].EntryID) {
              haveFlag = true
            }
          }
          if (!haveFlag) {
            that.editEntryInfo.push(editEntryInfo[i])
          }
        }
        that.$refs.editEntryInfoTable.doLayout()
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 编辑弹出框表格行删除方法
    editDeleteAddEntryInfoOne: function (index) {
      const that = this
      that.editEntryInfo.splice(index, 1)
    },

    // 编辑自动填充申请数量
    editAutoCompleteRequestQty: function () {
      const that = this
      for (let i = 0; i < that.editEntryInfo.length; i++) {
        let precision = that.editEntryInfo[i].Precision
        if (typeof (precision) !== 'number') {
          precision = 0
        }
        that.editEntryInfo[i].RequestQty = that.editEntryInfo[i].QtyMust - that.editEntryInfo[i].WMSRequestQty
        that.editEntryInfo[i].RequestQty = (that.editEntryInfo[i].RequestQty * Math.pow(10, precision) -
          that.editEntryInfo[i].RequestQty * Math.pow(10, precision) % 1 + ((that.editEntryInfo[i].RequestQty * Math.pow(10, precision) % 1) > 0 ? 1 : 0)) / Math.pow(10, precision)
      }
      that.$refs.editEntryInfoTable.doLayout()
    },

    // 保存修改
    editPickItemRequest: async function () {
      const that = this
      if (!that.editMainInfo.SourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (that.editMainInfo.SourceTranType && that.editEntryInfo.length <= 0) {
        that.$message.error('请选择源单！')
        return
      }
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.editEntryInfo.length; i++) {
        if (!that.editEntryInfo[i].ItemID) {
          that.$message.error('请选择物料')
          return
        }
        if (that.editEntryInfo[i].ICMOInterID !== that.editEntryInfo[0].ICMOInterID) {
          that.$message.error('请选择相同的委外订单的投料单！')
          return
        }
        if (!numberReg.test(that.editEntryInfo[i].RequestQty)) {
          that.$message.error('本次申请数量必须为数字！')
          return
        }
        if (parseFloat(that.editEntryInfo[i].RequestQty) < 0) {
          that.$message.error('本次申请数量不得小于0！')
          return
        }
        if (parseFloat(that.editEntryInfo[i].RequestQty) <= 0) {
          that.$message.error('本次申请数量必须大于0！')
          return
        }
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/OutsourcingManagement.SubContract.EditSubPickItemRequest', {
        main: that.editMainInfo,
        entrys: that.editEntryInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showEditPickItemRequestDialog = false
        that.$message.success('保存成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 变更数量弹出框显示方法
    showEditQtyAndRemarkDialogMD: function (row) {
      const that = this
      that.editRow = row
      that.newQty = row.Qty
      that.newRemark = row.Remark
      that.showEditQtyAndRemarkDialog = true
    },

    // 保存变更
    saveEdit: async function () {
      const that = this
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      if (!numberReg.test(that.newQty)) {
        that.$message.error('变更后数量必须为数字！')
        return
      }
      if (parseFloat(that.newQty) < 0) {
        that.$message.error('变更后数量不得小于0！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/OutsourcingManagement.SubContract.EditOneSubPickRequest', {
        row: that.editRow,
        newQty: that.newQty,
        newRemark: that.newRemark
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showEditQtyAndRemarkDialog = false
        that.$message.success('保存成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
